import * as actions from './discussionActivity.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { DiscussionActivityModel } from '@smarttask-common/src/lib/models/Discussion/Activity/Core/DiscussionActivityModel';

export const discussionAdapter = createEntityAdapter<DiscussionActivityModel>({
    selectId: (x) => x.activity_id,
});
export interface DiscussionActivityState extends EntityState<DiscussionActivityModel> {
    selected_activity_id: string;
}

export const initialState: DiscussionActivityState = discussionAdapter.getInitialState({
    selected_activity_id: undefined,
});

export function DiscussionActivityReducers(
    state: DiscussionActivityState = initialState,
    action: actions.DiscussionActivityActions
) {
    switch (action.type) {
        case actions.DiscussionActivityActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_activity_id: action.selected_activity_id };
            //console.log(state);
            return state;

        case actions.DiscussionActivityActionTypes.ADD_DISCUSSION_ACTIVITY:
            return discussionAdapter.addOne(action.discussionActivity, state);

        case actions.DiscussionActivityActionTypes.ADD_DISCUSSION_ACTIVITYS:
            return discussionAdapter.addMany(action.discussionActivitys, state);

        case actions.DiscussionActivityActionTypes.UPSERT_DISCUSSION_ACTIVITY:
            return discussionAdapter.upsertOne(action.discussionActivity, state);

        case actions.DiscussionActivityActionTypes.UPSERT_DISCUSSION_ACTIVITYS:
            return discussionAdapter.upsertMany(action.discussionActivitys, state);

        case actions.DiscussionActivityActionTypes.UPDATE_DISCUSSION_ACTIVITY:
            return discussionAdapter.updateOne(action.discussionActivity, state);

        case actions.DiscussionActivityActionTypes.UPDATE_DISCUSSION_ACTIVITYS:
            return discussionAdapter.updateMany(action.discussionActivitys, state);

        case actions.DiscussionActivityActionTypes.DELETE_DISCUSSION_ACTIVITY:
            // if(state.selectedDiscussionActivityId == action.id){
            //   state.selectedDiscussionActivityId = undefined;
            // }
            return discussionAdapter.removeOne(action.id, state);

        case actions.DiscussionActivityActionTypes.DELETE_DISCUSSION_ACTIVITYS:
            // if(action.ids.indexOf(state.selectedDiscussionActivityId) > -1){
            //   state.selectedDiscussionActivityId = undefined;
            // }
            return discussionAdapter.removeMany(action.ids, state);

        case actions.DiscussionActivityActionTypes.DELETE_ALL_DISCUSSION_ACTIVITYS:
            return discussionAdapter.removeMany(action.ids, state);

        case actions.DiscussionActivityActionTypes.DELETE_ALL:
            return discussionAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getDiscussionActivityState =
    createFeatureSelector<DiscussionActivityState>('discussionActivity');

export const { selectIds, selectEntities, selectAll, selectTotal } =
    discussionAdapter.getSelectors(getDiscussionActivityState);

const getSelectedDiscussionActivityIdState = (state: DiscussionActivityState) => {
    return state.selected_activity_id;
};
export const getSelectedDiscussionActivityId = createSelector(
    getDiscussionActivityState,
    getSelectedDiscussionActivityIdState
);

export const getSelectedDiscussionActivity = createSelector(
    getDiscussionActivityState,
    (state: DiscussionActivityState) => {
        if (state.selected_activity_id == undefined) {
            return undefined;
        }
        return state.entities[state.selected_activity_id];
    }
);
